import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLinebreak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLinebreak"><Path d="M3.5 12H16.75C18.8211 12 20.5 13.6789 20.5 15.75C20.5 17.8211 18.8211 19.5 16.75 19.5H12" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 19.5H7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 4.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 16.5L11.5 19.5L14.5 22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLinebreak;
